import { reactive, toRefs } from 'vue'
import axios from 'axios'

export default function useSafetySystems() {
  const safety_systems_state = reactive({
    safety_systems: [],
  })

  const listSafetySystems = async () => {
    await axios
      .get('/api/safety_systems/all')
      .then(function (response) {
        safety_systems_state.safety_systems = response.data.data
      })
      .catch(function () {
        //
      })
  }

  return { ...toRefs(safety_systems_state), listSafetySystems }
}
